module.exports = __webpack_public_path__ + "img/second.ee70ad6c.png";